import { render, staticRenderFns } from "./SheepGeneral.vue?vue&type=template&id=a6cbde14&"
import script from "./SheepGeneral.vue?vue&type=script&lang=js&"
export * from "./SheepGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports